export enum UserState {
    ACTIVE = "active",
    INACTIVE = "inactive",
    SUSPENDED = "suspended",
    PENDING = "pending",
}


export enum UsersPermissionsGuardEnum {
    USERS_VIEW = "users.view",
    USERS_CREATE = "users.create",
    USERS_UPDATE = "users.update",
    USERS_DELETE = "users.delete",
}